// Mapping-profile edit dialog panel layout config over the reusable panel-grid base.
import { type PanelGridConfig } from '@/common/panelGrid/panelGridLayout';

export type MappingProfilePanelId = 'core' | 'input' | 'output';

export const mappingProfileDialogStorageKey = 'mapping-profile-dialog-grid-layout';

export const mappingProfileDialogGridConfig: PanelGridConfig = {
  schemaVersion: 1,
  columns: 12,
  cellHeight: 34,
  margin: 6,
  collapsedRows: 1,
  window: {
    defaultWidth: 1100,
    defaultHeight: 720,
    minWidth: 720,
    minHeight: 480,
    maxWidth: 3840,
    maxHeight: 2160,
  },
  label: {
    default: 176,
    min: 64,
    max: 480,
  },
  panelOrder: ['core', 'input', 'output'],
  placements: {
    core: { x: 0, y: 0, w: 4, h: 10 },
    input: { x: 4, y: 0, w: 8, h: 16 },
    output: { x: 0, y: 10, w: 4, h: 8 },
  },
};
